import {
  Checkmark
} from "./chunk-62PCOUDV.mjs";

// src/checkbox/src/checkbox.tsx
import { forwardRef, useId } from "react";
import * as CheckboxComponent from "@radix-ui/react-checkbox";
import { Label, useDescribedBy } from "@thisisbud/gds-shared-utilities";
import { jsx, jsxs } from "react/jsx-runtime";
var Checkbox = forwardRef(
  ({
    disabled,
    onBlur,
    required,
    label,
    hint,
    errorMessage,
    name,
    value,
    onChange,
    checked,
    hideLabel
  }, ref) => {
    const labelId = useId();
    const hintId = useId();
    const errorId = useId();
    const hasHint = Boolean(hint);
    const hasError = Boolean(errorMessage);
    const describedBy = useDescribedBy(
      hasHint ? hintId : null,
      hasError ? errorId : null
    );
    return /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-[min-content,1fr]", children: [
      /* @__PURE__ */ jsx(
        CheckboxComponent.Root,
        {
          "aria-describedby": describedBy,
          checked,
          className: "common-focus flex size-5 shrink-0 items-center justify-center rounded-sm border border-surface-dark bg-surface-light text-surface-dark outline-none hover:bg-surface-subtle data-[disabled]:border-interactive-disabled data-[error=true]:border-state-negative-graphics data-[state=checked]:data-[disabled]:border-interactive-disabled data-[state=checked]:data-[error=true]:border-state-negative-graphics data-[state=checked]:bg-surface-dark data-[state=checked]:data-[disabled]:bg-interactive-disabled data-[state=checked]:data-[error=true]:bg-state-negative-graphics data-[state=checked]:data-[disabled]:hover:border-interactive-disabled data-[state=checked]:data-[error=true]:hover:border-state-negative-text data-[state=checked]:hover:border-surface-body data-[disabled]:hover:bg-surface-light data-[error=true]:hover:bg-state-negative-background data-[state=checked]:data-[disabled]:hover:bg-interactive-disabled data-[state=checked]:data-[error=true]:hover:bg-state-negative-text data-[state=checked]:hover:bg-surface-body",
          "data-error": hasError,
          disabled,
          id: labelId,
          name,
          ref,
          required,
          value,
          onBlur,
          onCheckedChange: (state) => onChange?.(state),
          children: /* @__PURE__ */ jsx(CheckboxComponent.Indicator, { className: "scale-[65%] text-surface-light", children: /* @__PURE__ */ jsx(Checkmark, {}) })
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: "grid gap-1", children: [
        /* @__PURE__ */ jsx(
          Label,
          {
            className: "pl-2.5",
            disabled: Boolean(disabled),
            hideLabel: Boolean(hideLabel),
            labelId,
            text: label
          }
        ),
        hasHint ? /* @__PURE__ */ jsx(
          "span",
          {
            className: "block pl-2.5 text-xs text-surface-body",
            id: hintId,
            children: hint
          }
        ) : null,
        hasError ? /* @__PURE__ */ jsx("span", { className: "sr-only", id: errorId, children: errorMessage }) : null
      ] })
    ] });
  }
);

export {
  Checkbox
};
